<template>
  <div>
    <table class="table" style="width:100%;">
      <thead>
        <tr>
          <th><abbr><i class="fa fa-tag" aria-hidden="true"></i></abbr></th>
          <th><abbr><i class="far fa-image"></i></abbr></th>
          <th><abbr>Naam</abbr></th>
          <th><abbr><i class="fa fa-cubes" aria-hidden="true"></i></abbr></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in cart"
          :key="'cart-' + item.id"
          v-bind:class="{ cartshow : item.aantal > 0, cartremove : item.aantal < 0 }"
        >
          <th>{{ item.id }}</th>
          <th>
            <img v-if="item.image.includes('data')" :src="item.image" width="26" height="26">
            <img v-else :src="'https://panel.tegelexpert.nl/pages/' + item.image" width="26" height="26">
          </th>
          <th>{{ item.name }}</th>
          <th>{{ item.aantal }}</th>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'Cart',

  props: ['cart'],

  methods: {
    
  },

  data() {
    return {
      
    }
  },
}
</script>

<style>
  .cartshow th {
    color:green !important;
  }

  .cartremove th {
    color:red !important;
  }
</style>
